import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UtilServico } from './util.servico';
import { UtilDadosLogado } from './util.logado';
import { delay, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class TransmissaoA1Service {
  private transmissaoA1Subject = new BehaviorSubject<boolean>(false);
  private tipo_assinatura: string = "";
  private db_config: any = null;
  private usuario_id: number = 0;

  constructor(
    private usuarioLogado: UtilDadosLogado,
    private sendHttp: UtilServico
  ) {
    const { usuario_id, db_config, tipo_assinatura } = this.usuarioLogado.DadosAcesso();
    this.tipo_assinatura = tipo_assinatura;
    this.db_config = db_config;
    this.usuario_id = usuario_id;
  }

  // Observable para o componente se inscrever
  transmitindo$ = this.transmissaoA1Subject.asObservable();

  // Método para atualizar o status da transmissão
  atualizarStatus(active: boolean) {
    this.transmissaoA1Subject.next(active);
  }

  async realizarTransmissao(data: any, alert: boolean = true): Promise<void> {

    
    try{
      this.atualizarStatus(true);
        return new Promise((resolve, reject) => {
          this.sendHttp
            .Post(
              'TabelaRubrica/LoteEnvioA1Individual',
              {
                metodo: 'ExEsocial',
                ambiente: data.Ambiente,
                retaguarda_id: data.Retaguarda,
                usuario_id: this.usuario_id,
                db_config: this.db_config,
                origem_dado_id: this.db_config.origem_dado_id,
              },
              true
            )
            .pipe(finalize(() => this.atualizarStatus(false)))
            .subscribe(
              async (response: any) => {
                if (alert) {
                  await Swal.fire({
                    title: 'Transmissão',
                    html: response.message,
                    type: 'success',
                    timer: 3000,
                    showConfirmButton: false,
                  });
                }
                resolve(); // Sucesso
              },
              async (error: any) => {
                if (alert) {
                  await this.showWarning(JSON.parse(error._body).message);
                }
                reject(error); // Falha
                return null;
              }
            );
        });
        
      }catch( catchError ){
        this.atualizarStatus(false);
        return null;
      };
  }
  

  async showWarning(message: string) {
    await Swal.fire({
      title: 'Atenção',
      text: message,
      type: 'warning',
      timer: 5000,
      showConfirmButton: false
    });
  }

}
